import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import createPersist, { createStorage } from 'vuex-localstorage';

import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default new Vuex.Store({
	plugins: [
		createPersist({
			namespace: 'enfgestor-localcast',
			initialState: state,
			expires: 7 * 24 * 60 * 60 * 1e3,
		}),
	],
	getters,
	actions,
	mutations,
});



// WEBPACK FOOTER //
// ./src/vuex/index.js